import * as actionTypes from '../constants/ActionTypes';

export const updateMemberRequestSuccess = (topicId, id) => ({
  type: actionTypes.UPDATE_APPROVAL_ID,
  payload: {
    topicId,
    id,
  },
});

export const cancelMemberRequestSuccess = (topicId) => ({
  type: actionTypes.UPDATE_APPROVAL_ID,
  payload: {
    topicId,
    id: null,
  },
});
